// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentsFilter_container__1bseT"};